// @flow
import React from 'react';
import Tips from '../../components/tips/Tips';
import usePods from '../../hooks/pods';

export default function TipsPage({
	history,
	location,
}: {
	history: { replace: (any) => void },
	location: { state: any },
}) {
	const { state } = location;
	const [{ affiliateActive = false, selectedPod } = {}] = usePods();

	const handleClose = () => {
		history.replace({ pathname: '/products', state });
	};

	return (
		<section style={{ height: '100vh' }}>
			<Tips onClose={handleClose} affiliate={affiliateActive} selectedPod={selectedPod}/>;
		</section>
	);
}
